import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import type { StripePrice } from "./types";
import { CATALOG_PRICES_QUERY_KEY } from "./use-prices-list";

async function archivePrice(id: string): Promise<StripePrice> {
  return httpClient<StripePrice>(`/api/admin/catalog/prices/${encodeURIComponent(id)}/archive`, {
    method: "POST",
  });
}

export function useArchivePrice() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: archivePrice,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CATALOG_PRICES_QUERY_KEY });
    },
  });
}
